import { Link } from "react-router-dom";
import { ArrowUpRight, Mail } from "lucide-react";
import { EMAIL } from "@/constants/site";
import { MODALITIES } from "@/constants/modalities";

const Footer = () => (
  <footer data-testid="site-footer" className="bg-ink text-white">
    <div className="bg-blueprint-grid-dark">
      <div className="mx-auto max-w-7xl px-5 py-16 md:px-8 md:py-20">
        <div className="flex flex-col justify-between gap-10 border-b border-white/10 pb-12 md:flex-row md:items-end">
          <div>
            <p className="eyebrow !text-azure">Start your project</p>
            <p className="mt-4 max-w-md font-heading text-2xl font-extrabold tracking-tight md:text-3xl">
              Clear answers. Buildable reports. Faster starts.
            </p>
          </div>
          <Link
            to="/request"
            data-testid="footer-cta-request"
            className="group flex w-fit items-center gap-2 bg-white px-6 py-3.5 text-sm font-semibold text-ink transition-colors duration-200 hover:bg-azure hover:text-white"
          >
            Request a Shielding Design
            <ArrowUpRight size={16} className="transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </div>

        <div className="grid gap-10 pt-12 sm:grid-cols-2 lg:grid-cols-[1.3fr_1fr_1fr_1.2fr]">
          <div>
            <div className="flex items-center gap-3">
              <img src="/logo-mark.png" alt="Heartland Physics logo" className="h-9 w-9 rounded-md object-contain" />
              <span className="font-heading text-sm font-extrabold tracking-[0.18em]">HEARTLAND PHYSICS</span>
            </div>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/60">
              A principal-led radiation shielding practice for diagnostic imaging facilities. Every report is prepared directly by Lancer Smith, M.S.
            </p>
          </div>
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.28em] text-white/40">Pages</p>
            <div className="mt-4 flex flex-col gap-2.5">
              {[
                { to: "/", label: "Home", id: "home" },
                { to: "/request", label: "Shielding Design Request", id: "request" },
                { to: "/shielding-design", label: "Shielding Design", id: "shielding-design" },
                { to: "/shielding-plan", label: "Shielding Plan", id: "shielding-plan" },
                { to: "/insights", label: "Insights", id: "insights" },
                { to: "/about", label: "About", id: "about" },
                { to: "/contact", label: "Contact", id: "contact" },
              ].map((l) => (
                <Link key={l.id} to={l.to} data-testid={`footer-link-${l.id}`} className="w-fit text-sm text-white/70 transition-colors hover:text-white">
                  {l.label}
                </Link>
              ))}
            </div>
          </div>
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.28em] text-white/40">Shielding Design</p>
            <div className="mt-4 flex flex-col gap-2.5">
              {MODALITIES.map((m) => (
                <Link key={m.slug} to={`/shielding-design/${m.slug}`} data-testid={`footer-modality-${m.slug}`} className="w-fit text-sm text-white/70 transition-colors hover:text-white">
                  {m.name}
                </Link>
              ))}
            </div>
          </div>
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.28em] text-white/40">Contact</p>
            <div className="mt-4 flex flex-col gap-3">
              <a href={`mailto:${EMAIL}`} data-testid="footer-email-link" className="flex w-fit items-center gap-2 text-sm text-white/70 transition-colors hover:text-white">
                <Mail size={14} /> {EMAIL}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-2 border-t border-white/10 pt-6 text-xs text-white/40 md:flex-row md:items-center md:justify-between">
          <p>© {new Date().getFullYear()} Heartland Physics. All rights reserved.</p>
          <p>Shielding and plan-review requirements vary by project and jurisdiction.</p>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
